<template>
  <div class="codes-matrix-loader">
    <b-field :label="type" v-for="type in types" :key="type">
      <b-select value expanded @input="code => onSelect(type, code)">
        <option value>Please select</option>
        <option value="all">All</option>
        <option v-for="code in codes[type]" :value="code.id" :key="code.id">
          {{ code.name }}
        </option>
      </b-select>
    </b-field>
    <br />
    <b-field>
      <b-radio v-model="mode" :native-value="$options.modes.insert">
        INSERT
      </b-radio>
      <b-radio v-model="mode" :native-value="$options.modes.delete">
        DELETE
      </b-radio>
    </b-field>
    <b-field>
      <p class="control">
        <b-button expanded :loading="loading" @click="create">CREATE</b-button>
      </p>
    </b-field>
  </div>
</template>

<script>
import { CodeService } from "@/services/code.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  codeService: CodeService,
  modes: {
    insert: "insert",
    delete: "delete"
  },
  data: () => ({
    codes: [],
    selected: {},
    mode: null,
    loading: false
  }),
  computed: {
    types() {
      return Object.keys(this.codes);
    }
  },
  created() {
    this.mode = this.$options.modes.insert;
    this.fetch();
  },
  methods: {
    async fetch() {
      const codes = await this.$options.codeService
        .all({ inactive: 1 })
        .then(response => JsonDenormalizer.denormalize(response));

      this.codes = codes.reduce((acc, code) => {
        if (code.type) {
          if (!acc[code.type]) {
            acc[code.type] = [];
          }
          acc[code.type].push(code);
        }
        return acc;
      }, {});
    },
    async create() {
      this.loading = true;

      try {
        const codeIds = Object.keys(this.selected).reduce((acc, type) => {
          if (this.selected[type]) {
            if (this.selected[type] === "all") {
              acc.push(...this.codes[type].map(code => code.id));
            } else {
              acc.push(this.selected[type]);
            }
          }
          return acc;
        }, []);

        const reverse = this.mode === this.$options.modes.delete;

        await this.$options.codeService.associateCodes(codeIds, { reverse });

        this.$buefy.toast.open({
          message: "Codes has been associated.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (errr) {}

      this.loading = false;
    },
    onSelect(type, code) {
      this.selected[type] = code;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/CodesMatrixManager/partials/matrixCodeLoader.vue